import { j as c } from "../../jsx-runtime-Drh4NO5G.mjs";
import { GrapheneSVG as d } from "../../util/GrapheneSVG.js";
import { svgIcons as i } from "./svg-icons.js";
import '../../assets/icon.css';const _ = "var(--color-surface-sf-4)", l = "_interaction_82ukv_130", u = "_icon_82ukv_106", g = "_inverse_82ukv_112", v = "_secondary_82ukv_115", y = "_warning_82ukv_118", x = "_info_82ukv_121", z = "_error_82ukv_124", k = "_success_82ukv_127", p = "_brand_82ukv_133", f = "_outlineWidthFrame_82ukv_1", a = {
  neutral: _,
  interaction: l,
  "layering-z-index-surface": "var(--layering-z-index-surface)",
  "layering-z-index-over-surface": "var(--layering-z-index-over-surface)",
  "layering-z-index-popup": "var(--layering-z-index-popup)",
  "layering-z-index-dialog": "var(--layering-z-index-dialog)",
  "layering-z-index-callout": "var(--layering-z-index-callout)",
  "layering-z-index-dropdown": "var(--layering-z-index-dropdown)",
  "layering-z-index-toast": "var(--layering-z-index-toast)",
  "layering-z-index-snackbar": "var(--layering-z-index-snackbar)",
  "layering-z-index-errorbar": "var(--layering-z-index-errorbar)",
  "layering-z-index-tooltip": "var(--layering-z-index-tooltip)",
  "layering-z-index-drag": "var(--layering-z-index-drag)",
  "layering-z-index-loadingbar": "var(--layering-z-index-loadingbar)",
  icon: u,
  inverse: g,
  secondary: v,
  warning: y,
  info: x,
  error: z,
  success: k,
  brand: p,
  "interaction-contrast-1": "_interaction-contrast-1_82ukv_136",
  "interaction-disabled": "_interaction-disabled_82ukv_139",
  "success-2": "_success-2_82ukv_142",
  "information-2": "_information-2_82ukv_145",
  "secondary-2": "_secondary-2_82ukv_148",
  "error-2": "_error-2_82ukv_151",
  outlineWidthFrame: f
}, j = Object.keys(i), o = "Icon";
function m({ name: n, fill: r = "default", size: e, ariaHidden: t = !1, ...s }) {
  return /* @__PURE__ */ c.jsx(
    d,
    {
      src: i[n],
      height: e,
      width: e,
      "data-icon-name": n,
      "data-component": o,
      ariaHidden: t,
      className: ["icon", n, r, a.icon, a[r]].filter(Boolean).join(" "),
      ...s
    }
  );
}
m.displayName = o;
export {
  m as Icon,
  j as IconNames
};
//# sourceMappingURL=icon.js.map
